const CONDITIONS = [
  "Back Pain",
  "Shoulder Pain",
  "Sciatica",
  "TMJ",
  "Headaches",
  "Migraines",
  "Whiplash",
  "Concussion",
  "Knee Pain",
  "Plantar Fasciitis",
  "Neck Pain",
  "Hip Pain",
];

export default function Conditions() {
  // duplicated for seamless marquee loop
  const loop = [...CONDITIONS, ...CONDITIONS];
  return (
    <section
      id="conditions"
      data-testid="conditions-section"
      className="relative py-20 sm:py-24 bg-blue-50/40 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="max-w-3xl">
          <div className="text-xs uppercase tracking-[0.2em] font-semibold text-blue-800 mb-4">
            Conditions Treated
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900 leading-[1.1]">
            If pain is your unwanted companion, you're in the right place.
          </h2>
          <p className="mt-5 text-lg text-slate-600 leading-relaxed">
            I love working with complex, stubborn cases — the ones other therapists have struggled with.
            Below are some of the most common conditions clients come to KneadRelief for.
          </p>
        </div>
      </div>

      <div className="mt-14 relative">
        <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-blue-50/90 to-transparent z-10 pointer-events-none" />
        <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-blue-50/90 to-transparent z-10 pointer-events-none" />

        <div className="flex kr-marquee-track whitespace-nowrap">
          {loop.map((c, i) => (
            <div
              key={`${c}-${i}`}
              data-testid={`condition-pill-${i}`}
              className="shrink-0 mx-3 px-7 py-4 rounded-full bg-white border border-blue-100 shadow-sm font-display font-semibold text-xl sm:text-2xl text-slate-800 hover:text-blue-800 hover:border-blue-300 transition-colors"
            >
              <span className="text-blue-300 mr-3">+</span>
              {c}
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 mt-12">
        <p className="text-center text-slate-600">
          Struggling with something not listed?{" "}
          <a
            href="mailto:info@kneadrelief.ca?subject=I%20have%20a%20problem%20and%20I%27d%20like%20to%20know%20if%20you%20can%20help%20me!"
            data-testid="conditions-email-link"
            className="font-semibold text-blue-800 underline-offset-4 hover:underline"
          >
            Email me directly
          </a>{" "}
          — I love complex cases.
        </p>
      </div>
    </section>
  );
}
